module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__untersuchung-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 2
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__untersuchung-main-wrapper"
  }, [_c('div', {
    staticClass: "ksm-modus__untersuchung-main"
  }, [_c('div', {
    staticClass: "ksm-flex-1"
  }, [_c('deepzoom-view', {
    key: "keep_untersuchung_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-untersuchung-footer"
  }, [_c('foot-thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": _vm.seiteIdx,
      "aligen": 'horizontal'
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-615432ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modus/Untersuchung.vue
// module id = 1976
// module chunks = 1